import React from "react";
import { Link } from "react-router-dom";
import SeoHelmet, { breadcrumbSchema } from "../components/SeoHelmet";
import { BLOG_POSTS } from "../data/blog";
import { ArrowRight } from "lucide-react";

export default function Blog() {
    return (
        <>
            <SeoHelmet
                title="Blog — CSV Guides, Tutorials, and Insights"
                description="Plain-English articles about CSV files, editing, importing, exporting, and modern data workflows. Written by Flying Fitz."
                schema={breadcrumbSchema([{ label: "Home", href: "/" }, { label: "Blog", href: "/blog" }])}
            />
            <header className="border-b border-black/10">
                <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">
                    <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted">/ articles</div>
                    <h1 className="font-display font-black tracking-tighter text-5xl md:text-6xl mt-3">The OpenCSV blog</h1>
                    <p className="mt-5 text-ink-soft max-w-2xl">Plain-English guides about CSV files, editing, importing, exporting, and modern data workflows. Written by <Link to="/about" className="underline text-cobalt">Flying Fitz</Link>.</p>
                </div>
            </header>

            <section className="mx-auto max-w-4xl px-4 md:px-8 py-12">
                <ul className="space-y-4">
                    {BLOG_POSTS.map((p) => (
                        <li key={p.slug} className="border border-black/10 bg-white hover:border-cobalt transition-colors" data-testid={`blog-post-${p.slug}`}>
                            <Link to={`/blog/${p.slug}`} className="block p-6">
                                <div className="flex items-center justify-between gap-3 flex-wrap">
                                    <span className="ui-heading text-xs uppercase tracking-widest text-cobalt">/ {p.category}</span>
                                    <span className="text-xs text-ink-muted">{p.date} · {p.readTime}</span>
                                </div>
                                <h2 className="font-display font-black tracking-tighter text-2xl md:text-3xl mt-2">{p.title}</h2>
                                <p className="text-sm text-ink-soft mt-2">{p.excerpt}</p>
                                <span className="mt-3 inline-flex items-center gap-1 text-sm text-cobalt ui-heading font-semibold">Read article <ArrowRight size={14} /></span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </section>
        </>
    );
}
